import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4135f568")

_pushScopeId("data-v-4135f568")
const _hoisted_1 = {
  key: 0,
  class: "error text-left text-error-message"
}
const _hoisted_2 = {
  key: 1,
  class: "error text-error-server-message"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    (_ctx.errorMessage)
      ? (_openBlock(), _createBlock("div", _hoisted_1, " ❌ " + _toDisplayString(_ctx.errorMessage), 1))
      : (_ctx.errorServer.length > 0)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode("div", null, "❌ " + _toDisplayString(_ctx.errorServer[0]), 1)
          ]))
        : _createCommentVNode("", true)
  ]))
})